import React, { useEffect, useState } from "react";
import { TermsConditionStyle } from "./style";
import { useNavigate } from "react-router-dom";
import arrowLeft from "../../images/bannersectionImages/arrowLeft.png";
import usehook from "./usehook";
const TermsCondition = () => {
  const [terms, setTerms] = useState([]);
  const { getAllTerms } = usehook();

  const fetchedData = async () => {
    try {
      const res = await getAllTerms();
      setTerms(res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchedData();
  }, []);

  const navigate = useNavigate();
  const backTo = () => {
    navigate("/");
  };

  return (
    <TermsConditionStyle>
      <div className="d-flex p-4" style={{ cursor: "pointer" }}>
        <div className="" onClick={backTo}>
          <img src={arrowLeft} />
        </div>
        <div className="text-center m-auto">
          <h3>Terms & Conditions</h3>
        </div>
      </div>

      {terms && terms.terms_and_conditions ? (
        <div className="p-4">
          <div
            dangerouslySetInnerHTML={{ __html: terms.terms_and_conditions }}
          />
        </div>
      ) : (
        <div className="text-center text-danger">No Record Found</div>
      )}
    </TermsConditionStyle>
  );
};

export default TermsCondition;
